import {Command} from "../decorators/command.decorator";
import {Keyword} from "../domain/entities/keyword.entity";
import {CommandName} from "./command-name.enum";
import {AbstractCommand} from "./abstract.command";

/**
 * Command to delete a keyword entity.
 * Accepts the full entity; the transformer extracts the UID for the backend payload.
 */
@Command({type: 'delete', prototype: Keyword})
export class DeleteKeywordCommand extends AbstractCommand<Keyword> {

    public name: CommandName = CommandName.DELETE_KEYWORD;

    public tags = ['entity', 'delete', 'keyword'];

    constructor(payload: Keyword) {
        super('keyword', payload.uid, payload);
    }

}
